import { useContext } from 'react';
import ProjectProgressionContext from './context';
import { onComponentLoading } from './actions';

const useComponentLoading = compKey => {
  const {
    dispatch,
    state: {
      loadingMap: { [compKey]: isLoading }
    }
  } = useContext(ProjectProgressionContext);

  const setIsLoading = isLoading =>
    dispatch(onComponentLoading(compKey, isLoading));

  return [isLoading, setIsLoading];
};

export default useComponentLoading;
